<template>
  <div class="select-startstop">
    <section class="title-bar">
      <div class="hero-body">
        <p class="title">作業場所の選択</p>
        <p class="subtitle">作業場所を選択してください。</p>
      </div>
    </section>

    <div class="block"></div>

    <div v-for="(row, row_index) in place_rows" :key="row.id" class="container">
      <div class="tile is-ancestor">
        <div
          v-for="(place, col_index) in row"
          :key="place.id"
          v-on:click="select_place_clicked(row_index, col_index)"
          class="tile is-parent is-3"
        >
          <article class="tile is-child notification is-success">
            <p class="title">{{ place }}</p>
          </article>
        </div>
      </div>
    </div>
    <b-loading
      :is-full-page="true"
      v-model="isLoading"
      :can-cancel="false"
      style="background-color: rgba(0, 0, 0, 0.8)"
    ></b-loading>
  </div>
</template>

<script>
import ApiService from '../services/ApiService';

export default {
  name: 'SelectPlace',
  data: function () {
    return {
      action: '',
      places: [],
      place_rows: [[]],
      isLoading: false,
    };
  },
  watch: {
    places: function (newValue, oldValue) {
      var rows = [];
      var row = [];
      //表示上、4つの要素毎に、containerを追加して改行するために、リストを分割する
      newValue.forEach((element, index) => {
        row.push(element);
        if (index % 4 == 3) {
          rows.push(row);
          row = [];
        }
      });
      if (row.length !== 0) {
        rows.push(row);
      }
      this.place_rows = rows;
    },
  },
  mounted() {
    // クエリパラメータのバリデーション処理
    if (!(this.$route.query.action == 'start' || this.$route.query.action == 'end')) {
      this.$buefy.dialog.alert({
        message: '不正な遷移です。最初からやり直してください。',
        onConfirm: () => {
          this.$router.push('/login');
        },
      });
    }
    this.action = this.$route.query.action;
    this.uid = this.$route.query.uid;

    // 作業場所一覧の取得
    const apiService = new ApiService();

    const me = this;

    this.isLoading = true;

    apiService.getPlaceList((response) => {
      this.isLoading = false;
      if (response.status == 200) {
        const placeResult = response.data?.result?.task_place_list;
        // リスト文字列をリストに変換
        this.places = placeResult.replace('[', '').replace(']', '').split(',');
      } else if (response.status == 401) {
        // トークン再取得失敗時にはログイン画面へ遷移
        me.$buefy.dialog.alert({
          message: 'ログインに失敗しました、管理者に再度ログインしてもらってください。',
          onConfirm: () => {
            this.$router.push('/admin_login');
          },
        });
      }
    });
  },
  methods: {
    select_place_clicked: function (row_index, col_index) {
      const workingAreaName = this.place_rows[row_index][col_index];
      this.$router.push(
        `/select-work?action=${this.action}&uid=${this.uid}&pname=${workingAreaName}`
        // router.push({ path: 'register', query: { plan: 'private' } }) のように用いる
      );
    },
  },
};
</script>
<style scoped>
section.title-bar {
  background-color: #008a75;
}
p.title {
  color: white;
}
p.subtitle {
  color: white;
}

article.tile.is-child.notification.is-success {
  background-color: #ff7d00;
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/SelectPlace.vue